// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Ubuntu+Mono:regular,italic,700,700italic);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Mynerve:regular);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --navbar-Height: 80px;
    --HeroVideo-Height: 100vh;

}

.hero-section {

    width: 100%;
    height: var(--HeroVideo-Height);
    margin-top: 0;
    border: 0;
    position: relative;
    align-items: center;
    justify-content: center;
}

.hero-section::after {
    position: absolute;
    top: 0;
    left: 0;
    content: '';
    width: 100%;
    height: var(--HeroVideo-Height);
    background-color: #000000;
    opacity: 0.5;
    z-index: 0;

}

.hero-head {
    color: white;
    position: absolute;
    top: 40%;
    right: 10%;
    z-index: 1;
    text-align: center;
  

}

.hero-video video {

    width: 100%;
    height: var(--HeroVideo-Height);
    object-fit: cover;
}

.hero-head h3,
h1,
h2 {
    color: white;
}

.hero-head h2 {
    font-weight: 400;
    font-size: 30px;

}

.hero-head h1 {

    font-size: 60px;

}

.button{
    margin-top: 15px;
}




/* Responsive For Tablet Screen size 767px to 1023px START */
@media (max-width:1023px) {


    .hero-head {

       
        padding: 5px;
        top: center;
        right: center;


    }
}

/* Responsive For Tablet Screen size 601px to 1023px END */








/*  */
/*  */
/* Responsive For Mobile Screen size 1024px to 1920px START */


@media (max-width:767px) {

    .hero-head {

        padding: 5px;
        top: 300px;
        left:0;
        right:0;
        margin-left:auto;
        margin-right:auto;

  
    }

    .hero-head h2 {
        font-size: 20px;
    }

    .hero-head h1 {
        font-size: 45px;
    }

}


/* Responsive For Mobile Screen size 1024px to 1920px END */





/* extra breakpoints (mobile) */

@media (max-width:425px){

    .hero-head {

        padding: 5px;
        top: 300px;
        left:0;
        right:0;
        margin-left:auto;
        margin-right:auto;
       
    }

    .hero-head h2 {
        font-size: 15px;
    }

    .hero-head h1 {
        font-size: 35px;
    }

}`, "",{"version":3,"sources":["webpack://./src/Components/HomeheroStyles.css"],"names":[],"mappings":"AAGA;IACI,qBAAqB;IACrB,yBAAyB;;AAE7B;;AAEA;;IAEI,WAAW;IACX,+BAA+B;IAC/B,aAAa;IACb,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,WAAW;IACX,+BAA+B;IAC/B,yBAAyB;IACzB,YAAY;IACZ,UAAU;;AAEd;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,UAAU;IACV,kBAAkB;;;AAGtB;;AAEA;;IAEI,WAAW;IACX,+BAA+B;IAC/B,iBAAiB;AACrB;;AAEA;;;IAGI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,eAAe;;AAEnB;;AAEA;;IAEI,eAAe;;AAEnB;;AAEA;IACI,gBAAgB;AACpB;;;;;AAKA,4DAA4D;AAC5D;;;IAGI;;;QAGI,YAAY;QACZ,WAAW;QACX,aAAa;;;IAGjB;AACJ;;AAEA,0DAA0D;;;;;;;;;AAS1D,KAAK;AACL,KAAK;AACL,6DAA6D;;;AAG7D;;IAEI;;QAEI,YAAY;QACZ,UAAU;QACV,MAAM;QACN,OAAO;QACP,gBAAgB;QAChB,iBAAiB;;;IAGrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;AAEJ;;;AAGA,2DAA2D;;;;;;AAM3D,+BAA+B;;AAE/B;;IAEI;;QAEI,YAAY;QACZ,UAAU;QACV,MAAM;QACN,OAAO;QACP,gBAAgB;QAChB,iBAAiB;;IAErB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;AAEJ","sourcesContent":["@import url(https://fonts.googleapis.com/css?family=Ubuntu+Mono:regular,italic,700,700italic);\n@import url(https://fonts.googleapis.com/css?family=Mynerve:regular);\n\n:root {\n    --navbar-Height: 80px;\n    --HeroVideo-Height: 100vh;\n\n}\n\n.hero-section {\n\n    width: 100%;\n    height: var(--HeroVideo-Height);\n    margin-top: 0;\n    border: 0;\n    position: relative;\n    align-items: center;\n    justify-content: center;\n}\n\n.hero-section::after {\n    position: absolute;\n    top: 0;\n    left: 0;\n    content: '';\n    width: 100%;\n    height: var(--HeroVideo-Height);\n    background-color: #000000;\n    opacity: 0.5;\n    z-index: 0;\n\n}\n\n.hero-head {\n    color: white;\n    position: absolute;\n    top: 40%;\n    right: 10%;\n    z-index: 1;\n    text-align: center;\n  \n\n}\n\n.hero-video video {\n\n    width: 100%;\n    height: var(--HeroVideo-Height);\n    object-fit: cover;\n}\n\n.hero-head h3,\nh1,\nh2 {\n    color: white;\n}\n\n.hero-head h2 {\n    font-weight: 400;\n    font-size: 30px;\n\n}\n\n.hero-head h1 {\n\n    font-size: 60px;\n\n}\n\n.button{\n    margin-top: 15px;\n}\n\n\n\n\n/* Responsive For Tablet Screen size 767px to 1023px START */\n@media (max-width:1023px) {\n\n\n    .hero-head {\n\n       \n        padding: 5px;\n        top: center;\n        right: center;\n\n\n    }\n}\n\n/* Responsive For Tablet Screen size 601px to 1023px END */\n\n\n\n\n\n\n\n\n/*  */\n/*  */\n/* Responsive For Mobile Screen size 1024px to 1920px START */\n\n\n@media (max-width:767px) {\n\n    .hero-head {\n\n        padding: 5px;\n        top: 300px;\n        left:0;\n        right:0;\n        margin-left:auto;\n        margin-right:auto;\n\n  \n    }\n\n    .hero-head h2 {\n        font-size: 20px;\n    }\n\n    .hero-head h1 {\n        font-size: 45px;\n    }\n\n}\n\n\n/* Responsive For Mobile Screen size 1024px to 1920px END */\n\n\n\n\n\n/* extra breakpoints (mobile) */\n\n@media (max-width:425px){\n\n    .hero-head {\n\n        padding: 5px;\n        top: 300px;\n        left:0;\n        right:0;\n        margin-left:auto;\n        margin-right:auto;\n       \n    }\n\n    .hero-head h2 {\n        font-size: 15px;\n    }\n\n    .hero-head h1 {\n        font-size: 35px;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
